const cards = {
  cards: 'Identifiants',
  search_by_organization_or_site: 'Identifiant, Utilisateur assigné',
  search_by_user: 'Identifiant',
  options: 'Options',
  general_information: 'Informations générales',
  assign_user: 'Attribuer un utilisateur',
  assigned_user: 'Utilisateur désigné',
  assign_msg: 'Voulez-vous assigner la carte {{ card }} à {{ user }} ?',
  assign_reader:
    'Voulez-vous numériser avec le lecteur {{ reader }} du site {{ site }} ?',
  delete_msg: 'Voulez-vous supprimer la carte {{ card }} ?',
  unassign_msg: 'Voulez-vous désassigner {{ user }} de la carte {{ card }} ?',
  delete_card_multiple_sites:
    'Remarque : cet identifiant est associé à plusieurs sites et sera supprimé de tous.',
  readers: 'Lecteurs',
  scan_card: 'Scanner la carte',
  search_devices: 'Rechercher un dispositif',
  scan_status: 'État de la numérisation : ',
  enrolled: 'Enregistré',
  discover: 'Découvrir KPROG',
  use_kprog: 'Utiliser KPROG',
  kprog: 'KPROG',
  table: {
    card: 'IDENTIFIANT',
    state: 'ÉTAT',
    user_name: 'NOM',
    reader: 'LECTEUR',
    site: 'SITE',
  },
  form: {
    display_name: "Nom d'affichage",
    facility_code: "Code d'installation",
    card_code: 'Code Identifiant',
    activation_date: "Date d'activation",
    expiry_date: "Date d'expiration",
    card_format: "Format de l'identifiant",
    card_number_hex: 'Numéro de carte hexadécimal',
    all: 'Tout',
    stolen: 'Volé',
    lost: 'Perdu',
    status: 'État',
    select_a_reader: 'Sélectionnez un lecteur',
    csn: 'C.S.N. (numéro imprimé)',
    registration_code: "Code d'enregistrement",
  },
  pin_option: {
    not_used: 'Non utilisé',
    start_lockdown: 'Démarrer le confinement',
    stop_lockdLock: 'Arrêtez le confinement',
    lockdown_grant: "Le confinement accorde l'accès",
    area_secured: 'Garder la porte sécurisée (maintenir le confinement)',
  },
  list: {
    column_credential_number: "Numéro d'identifiant",
    column_csn: 'CSN',
    column_facility_code: "Code d'installation",
    column_credential_id: "ID d'identifiant",
    column_assigned_user: 'Utilisateur assigné',
    column_lockdown: 'Option de confinement',
    column_stolen: 'Volé',
    column_lost: 'Perdu',
    lockdown_display: {
      not_used: 'Aucune',
      start: 'Désactivé pendant le confinement',
      stop: 'Arrêter le confinement',
      grant_access: 'Contourner pendant le confinement',
      maintain: 'Maintenir la porte sécurisée',
    },
    pill_stolen: 'Volé',
    pill_lost: 'Perdu',
  },
};

export default cards;
